<template>
    <p-modal v-if="display" @onClickBG="onCancel">
        <div slot="content">
            <div class="title">
                您已選擇刷卡支付
            </div>
            <div class="detail">
                <div>
                    您送出任務後，系統即預刷此筆任務總費用，待任務結束後，<span class="red">將立即自動刷卡，進行多退少補。</span>
                </div>
                <div>
                    * 多退：將任務多餘款項退還給您，因銀行作業關係，約需28天後退回帳戶，若有款項疑慮請聯繫跑跑腿客服。
                </div>
                <div>
                    * 少補：將任務不足款項補刷，刷完將另行通知。
                </div>
            </div>
            <label for="noShow" class="checkbox">
                <input id="noShow" type="checkbox" v-model="noShow" hidden>
                <img v-show="noShow" src="@/assets/img/check.svg">
                <img v-show="!noShow" src="@/assets/img/check-none.svg">
                我暸解了，下次不要再提醒
            </label>
        </div>
        <div slot="buttons" class="buttons">
            <div class="confirm button" @click.stop="onConfirm">
                好
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';

    export default {
        name: 'PaymentDetailModal',
        components: {
            'p-modal': Modal
        },
        data() {
            return {
                display: false,
                noShow: false,
            };
        },
        methods: {
            onConfirm() {
                this.display = false;
                this.$emit('onConfirm');
                localStorage.setItem('no-show-payment', this.noShow);
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show() {
                this.display = true;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: left;
    }

    .detail {
        margin-top: 15px;
        font-size: 15px;
        color: #4a4a4a;
        text-align: left;

        .red {
            color: #F44336;
        }
    }

    .checkbox {
        display: flex;
        justify-content: center;
        font-size: 14px;
        color: #4a4a4a;
        margin-top: 25px;
        user-select: none;
        cursor: pointer;

        img {
            margin: auto 0;
        }
    }

    .button {
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        padding: 12px 0;
        color: #339933;
    }
</style>
